import { useFormikContext } from 'formik';
import * as uuid from 'uuid';

import { ScheduleMessage } from '../../../../types/ScheduleMessage';
import { useToasts } from '../../../cdl/Toast/useToasts';
import { startOfTimeZoneDayAsUtcIso } from '../../../common/helpers/dateFns.helper';
import { translate } from '../../../common/helpers/translate.helper';
import { CompareOverlayFlow } from '../../compare/overlay/CompareOverlayFlow';
import { FormikCreateEnquiryValues } from '../../create-enquiry/CreateEnquiryFlow';
import { OrderMode } from '../../create-enquiry/types/OrderMode';

interface Changed {
    receiverSupplierIds: string[];
    receiverContractIds?: string[];
    portId: string;
    dateDelivery?: {
        date: string;
        timeZoneId: string;
    };
}

interface FormikCompareOverlayProps {
    defaultContractId?: string;
    schedule: ScheduleMessage[];
}

const trackingId = uuid.v4();

export const FormikCompareOverlay = (props: FormikCompareOverlayProps) => {
    const { addErrorToast } = useToasts();
    const { values, setFieldValue, setFieldTouched } = useFormikContext<FormikCreateEnquiryValues>();

    return (
        <CompareOverlayFlow
            trackingId={trackingId}
            singleSupplierSelection={values.orderMode === OrderMode.DIRECT_ORDER}
            defaultContractId={props.defaultContractId}
            order={values}
            schedules={props.schedule.map((mappedSchedule) => ({
                ...mappedSchedule,
                etaWithZone: {
                    date: mappedSchedule.eta,
                    timeZoneId: mappedSchedule.port?.timeZoneId,
                },
            }))}
            onSubmit={(changed: Changed) => {
                if (values.orderMode === OrderMode.DIRECT_ORDER && changed.receiverSupplierIds.length !== 1) {
                    addErrorToast(translate('order.directOrder.selectExactlyOneSupplierToPlaceDirectOrder'));
                    return;
                }
                setFieldValue('receiverSupplierIds', changed.receiverSupplierIds);
                setFieldTouched('receiverSupplierIds', true, false);

                if (changed.receiverContractIds !== undefined) {
                    setFieldValue('receiverContractIds', changed.receiverContractIds);
                    setFieldTouched('receiverContractIds', true, false);
                }

                setFieldValue('portId', changed.portId);
                setFieldTouched('portId', true);

                if (changed.dateDelivery) {
                    const dateDeliveryFromSchedule = startOfTimeZoneDayAsUtcIso(
                        changed.dateDelivery.date,
                        changed.dateDelivery.timeZoneId
                    );

                    setFieldValue('dateDelivery', dateDeliveryFromSchedule);
                    setFieldTouched('dateDelivery', true);
                }
            }}
        />
    );
};
